import React from "react";

import { Preview } from "../../blocks/ai-assistant-popover/preview";
import { SelectChartType } from "../../blocks/ai-assistant-popover/select-chart-type";
import { Box } from "@towersystems/towersystems-design-system";
import Button from "../button";
import { startEditingReport } from "state/ui/report-builder/actions";
import { toDataType, resultToReportConfig, toChartType } from "./utils";
import page from "page";
import { connect } from "react-redux";
import { HiOutlineExternalLink } from "react-icons/hi";

function ChatCharts({ queries, isLoading, ...props }) {
  const [selectedChartType, setSelectedChartType] = React.useState();

  React.useEffect(() => {
    const firstQuery = queries[0];
    if (firstQuery) {
      const formatted = toChartType(firstQuery);
      setSelectedChartType(formatted);
    }
  }, [queries]);

  const formattedQueries = queries.map((qString) => {
    return qString;
  });

  const handleOnOpenInEditor = (originalQuery) => {
    const report = resultToReportConfig(originalQuery);
    props.startEditingReport(null, report);
    page("/report-builder/new");
  };

  // remove all except the last one
  const result = formattedQueries.slice(-1);

  return (
    <div>
      {result.length >= 1 && (
        <SelectChartType
          onChange={setSelectedChartType}
          selected={selectedChartType}
          dataType={toDataType(result[0])}
        />
      )}
      <div className="grow space-y-4">
        {result.map((q, k) => {
          return (
            <Box key={k}>
              <Box
                style={{
                  height: 500,
                }}
              >
                <Preview
                  {...q}
                  dataType={toDataType(q)}
                  chartType={selectedChartType}
                />
              </Box>

              <Box className="mt-4">
                <Button
                  onClick={() => handleOnOpenInEditor(q)}
                  href="#"
                  target="_blank"
                  fullWidth
                  borderless
                  className="hover:bg-gray-200"
                >
                  <div className="flex items-center justify-center text-gray-500 hover:text-[#4394e5]">
                    <span className="text-base font-semibold ">
                      Open in Chart Builder
                    </span>
                    <HiOutlineExternalLink className="ml-2" size={20} />
                  </div>
                </Button>
              </Box>
            </Box>
          );
        })}
      </div>
    </div>
  );
}

export default connect(undefined, {
  startEditingReport,
})(ChatCharts);
